
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import { Table } from "@common/src/utils/decorator";
import dayjs from "dayjs";
import { addCurrencyUnit } from "@common/src/utils/tools";

import t from "@common/src/i18n/t";
const category = namespace("parts-category");
const inventory = namespace("inventory");
const parts = namespace("parts");
@Component({
  components: {}
})
@Table("loadListData")
export default class SafetyInventoryList extends Vue {
  @inventory.Action deleteInventoryAlert;
  @category.Action getCategoryList;
  @inventory.Action queryAlertList;
  @parts.Action getPartsBrandList;
  dayjs = dayjs;
  emptyToLine = emptyToLine;
  t = t;
  splitThousands = splitThousands;
  addCurrencyUnit = addCurrencyUnit;
  orderList: any[] = [];
  importFlag = false;
  natureFlag = true;
  deleteBatch = false;
  searchForm = {
    serviceCategoryCode: "",
    serviceNumber: "",
    serviceName: "",
    updateTimeStart: "",
    updateTimeEnd: "",
    partsNumber: "",
    partsName: "",
    categoryCode: ""
  };
  get breadData() {
    return [
      { name: t("test.service-management"), path: "/service" },
      {
        name: this.$route.name === "partsAdd" ? t("service.new-maintenance") : t("setting.editing-spare-parts")
      }
    ];
  }
  created() {
    this.init();
  }
  addLeafFlag(list) {
    const f = function (list) {
      list.forEach(item => {
        if (!item.children || item.children.length < 1) {
          delete item.children;
        } else {
          f(item.children);
        }
      });
    };
    f(list);
    return list;
  }
  async init() {
    this.getParts();
    this.getBrandList();
    this.loadListData();
  }
  getBrandList() {
    this.getPartsBrandList().then(data => {
      this.brandList = this.$safeValue(data, "data.list", []).map(item => ({
        label: item.brandName,
        value: item.brandCode
      }));
    });
  }
  categoryList = [];
  async getParts() {
    const data = await this.getCategoryList();
    this.categoryList = this.addLeafFlag(this.$safeValue(data, "data", []));
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.queryAlertList({
      ...this.searchForm,
      clientType: "1",
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize
    }).then(data => {
      this.orderList = this.$safeValue(data, "data.list", []);
      return data;
    });
  }
  invoicingList: any[] = [];
  staffList: any[] = [];
  brandList: any[] = [];
  serviceName: string = "";
  get searchList() {
    return [
      {
        label: t("parts.name"),
        type: "input",
        value: "",
        prop: "partsName"
      },
      {
        label: t("v210801.spare-parts-code"),
        type: "input",
        value: "",
        prop: "partsNumber"
      },
      {
        label: t("setting.brand"),
        type: "select",
        selectList: this.brandList,
        value: "",
        prop: "brandCode"
      },
      {
        label: t("parts.category"),
        type: "cascader",
        prop: "categoryCode",
        value: "",
        options: this.categoryList,
        props: {
          label: "categoryName",
          value: "categoryCode"
        }
      }
    ];
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        if (item.prop === "updateTimeStart") {
          this.searchForm["updateTimeStart"] = item.value && item.value[0] ? item.value[0] : "";
          this.searchForm["updateTimeEnd"] = item.value && item.value[1] ? item.value[1] : "";
        } else if (item.prop) {
          this.searchForm[item.prop] = item.prop === "categoryCode" ? item.value[item.value.length - 1] : item.value;
        } else {
          this.searchForm[item.prop] = item.value;
        }
      }
    });
    this.loadListData();
  }
  handlePicking(row) {
    if (!row && !this.stringRows) {
      return this.$message.warning(t("v260.please-select-item-or-spare-parts"));
    }
    this.$router.push(`/inventory/safety-inventory-edit/${this.stringRows || row.partsCode}`);
  }
  deleteTips() {
    if (!this.stringRows) {
      return this.$message.warning(t("v260.please-select-item-or-spare-parts"));
    }
    this.deleteBatch = true;
  }
  async handelDelete(row) {
    if (!row && !this.stringRows) {
      return this.$message.warning(t("v260.please-select-item-or-spare-parts"));
    }
    const res = await this.deleteInventoryAlert({
      partsCodeArray: (this.stringRows || row.partsCode || row.serviceCode).split(",")
    });
    if (res.success) {
      this.$message.success(t("v210831.delete-succeeded"));
      this.loadListData();
      this.deleteBatch = false;
    }
  }

  showImportFlag() {
    this.$router.push("/inventory/safety-inventory-set");
  }
  enter(row) {
    if (row.serviceCommission.arrivalCommissionType !== "none") {
      this.natureFlag = true;
    } else if (row.serviceCommission.externalCommissionType !== "none") {
      this.natureFlag = false;
    }
  }
  selectRows = [];
  stringRows = "";
  handelSelect(selects) {
    this.selectRows = selects;
    let stringRows = selects.map(item => {
      return item.partsCode;
    });
    this.stringRows = stringRows.join(",");
  }
}
